module.exports = __webpack_public_path__ + "static/img/zgtsshzy.c3911e93.svg";